import React, { useEffect, useState, FC, ReactNode } from "react";

const DESIGN_HEIGHT = 1080;
const params = new URLSearchParams(window.location.search);
const scaleHeightEnabled = params.has("ScaleHeight");
const scaleFontsEnabled = params.has("ScaleFonts");

const customFontSize = params.get("ScaleFonts");
const baseFontSize = customFontSize
  ? parseFloat(customFontSize)
  : parseFloat(getComputedStyle(document.documentElement).fontSize);

const ScaleWrapper: FC<{ children: ReactNode }> = ({ children }) => {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    if (!scaleHeightEnabled && !scaleFontsEnabled) return;
    const update = () => {
      const ratio = window.innerHeight / DESIGN_HEIGHT;
      setScale(ratio);
      if (scaleFontsEnabled) {
        document.documentElement.style.fontSize = `${baseFontSize * ratio}px`;
      }
    };
    update();
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("resize", update);
      if (scaleFontsEnabled) {
        document.documentElement.style.fontSize = "";
      }
    };
  }, []);

  if (!scaleHeightEnabled) return <>{children}</>;

  return (
    <div style={{
      transform: `scale(${scale})`,
      transformOrigin: "top left",
      width: `${100 / scale}%`,
      height: `${100 / scale}%`,
    }}>
      {children}
    </div>
  );
};

export default ScaleWrapper;
